import { shopliftTesting } from 'utils/shoplift-testing';

export default (element, data) => {
  shopliftTesting(element, data);
}